(function cookieHandler(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Modules = global.NewHomeSource.Modules || {};

  const previousCookieHandler = global.NewHomeSource.Modules.cookieHandler;
  const partnerElement = global.document.getElementById('nhs_partnerID');

  /**
   * @constructs NewHomeSource.Modules.cookieHandler
   */
  function CookieHandler() {
  }

  /**
   * @public
   * createCookie: creates a new cookie for the *.newhomesource.com domain.
   *
   * @param {string} name of the cookie.
   * @param {any} value that will be stored in the cookie.
   * @param {number} days of expiration time for the cookie.
   * @param {boolean} isPartnerCookie true if the cookie name should include the partner ID information,
   * otherwise false.
   */
  CookieHandler.createCookie = function createCookie(name, value, days, isPartnerCookie) {
    let expires = '';
    let cookieName = name;

    if (isPartnerCookie && partnerElement) {
      cookieName += '_' + partnerElement.value;
    }

    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toGMTString();
    }

    document.cookie = `${cookieName}=${value}${expires}; path=/;`;
  };

  /**
   * @public
   * eraseCookie: deletes a cookie.
   *
   * @param {string} name of the cookie to delete.
   * @param {boolean} isPartnerCookie true if the cookie name should include the partner ID information,
   * otherwise false.
   */
  CookieHandler.eraseCookie = function eraseCookie(name, isPartnerCookie) {
    CookieHandler.createCookie(name, null, -1, isPartnerCookie);
  };

  /**
  * @public
  * readCookie: searches for a cookie and returns its value.
  *
  * @param {string} name of the cookie to be retrieved.
  * @param {boolean} isPartnerCookie true if the cookie name should include the partner ID information,
  * otherwise false.
  */
  CookieHandler.readCookie = function readCookie(name, isPartnerCookie) {
    let searchText = name;

    if (isPartnerCookie && partnerElement) {
      searchText += '_' + partnerElement.value;
    }

    searchText += '=';

    const items = document.cookie.split(';');
    const length = items.length;
    const nameLength = searchText.length;
    let cookieFound = null;

    for (let index = 0; index < length; index += 1) {
      if (items[index].trim().indexOf(searchText) === 0) {
        cookieFound = items[index];
        break;
      }
    }

    if (!cookieFound) {
      return null;
    }

    return cookieFound.trim().substring(nameLength);
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.Modules.cookieHandler to the previous script.
   */
  CookieHandler.noConflict = function noConflict() {
    global.NewHomeSource.Modules.cookieHandler = previousCookieHandler;
    return CookieHandler;
  };

  global.NewHomeSource.Modules.cookieHandler = CookieHandler;
}(window));
